import { render, staticRenderFns } from "./ProfileCollection.vue?vue&type=template&id=3e161994&"
import script from "./ProfileCollection.vue?vue&type=script&lang=js&"
export * from "./ProfileCollection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCollection.vue?vue&type=style&index=0&id=3e161994&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports